
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Progress from "./pages/Progress";
import Progress2 from "./pages/Progress2";
import Progress3 from "./pages/Progress3";
import Progress4 from "./pages/Progress4";
import { PlanningForm } from "@/components/PlanningForm";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/login" element={<Login />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/progress2" element={<Progress2 />} />
          <Route path="/progress3" element={<Progress3 />} />
          <Route path="/progress4" element={<Progress4 />} />
          <Route path="/planning-form" element={<PlanningForm />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
